<template>
    <div>
        <content-view v-show="$utils.renderWhen(this,'storageIndex')">
        <!-- 仓库管理 -->
        <div slot="header">
            <a-form :form="filterForm" layout="inline" class="store-one-form">
                <a-form-item label="仓库编号">
                    <a-input-number style="width:100%;" :min="1" :max="99999999999" placeholder="请输入" v-decorator="['id']"></a-input-number>
                </a-form-item>
                <a-form-item label="仓库名称">
                    <a-input placeholder="请输入" v-decorator="['name']"></a-input>
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button type="primary" @click="search">筛选</a-button>
                    <a-button @click="handleReset()">重置</a-button>
                </a-form-item>
            </a-form>
        </div>
        <div class="wrap-container-in">
            <a-button v-if="getBtnByAuth('addStorage')" class="mb16" type="primary" @click="openMondal()">新增仓库</a-button>
            <a-table
            bordered
            :dataSource="warehouse"
            :columns="columns"
            :pagination="pagination"
            :rowKey="record => record.id"
            @change="changePage"
            >
            <span slot="warehouseLevel" slot-scope="warehouseLevel">{{['','一级仓库','二级仓库'][warehouseLevel]}}</span>
            <span slot="action" slot-scope="a,row">
                <span v-if="getBtnByAuth('updateStorage')">
                    <a v-if="row.warehouseTypeId != 1" class="text-primary" @click="openMondal(row)">编辑</a>
                    <span v-else class="text-disabled">编辑</span>
                    <a-divider type="vertical"/>
                </span>
                <span v-if="getBtnByAuth('wareHouse')">
                    <a class="text-primary" @click="toWareHouse(row)">仓库存储</a>
                    <a-divider type="vertical"/>
                </span>
                <span v-if="getBtnByAuth('deleteStorage')">
                    <a-popconfirm
                        v-if="row.warehouseTypeId != 1"
                        :title="`确定删除该仓库吗？`"
                        @confirm="delectWarehouseList(row.id)"
                    >
                        <a class="text-primary">删除</a>
                    </a-popconfirm>
                    <span v-else class="text-disabled">删除</span>
                </span>
            </span>
            </a-table>
            <!-- 添加和编辑弹窗 -->
            <a-modal
            :title="storageTitle"
            :visible="newStorageVisible"
            @ok="addWarehouse"
            centered
            @cancel="handleCancel"
            >
                <a-form :form="formModelNewStorage">
                    <a-form-item label="仓库类型" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
                        <a-select
                            v-decorator="['warehouseTypeId',{rules: [{ required: true, message: '请输入仓库类型'}]}]"
                            placeholder="请选择"
                        >
                            <a-select-option
                            :value="item.id"
                            v-for="(item, index) in warehouseTypeOptions"
                            :key="index"
                            >{{item.typeName}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="仓库名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
                        <a-input
                            @blur="isWarehouseNameExist"
                            placeholder="请输入"
                            v-decorator="['name', {rules: [{ required: true, message: '请输入仓库名称' }]}]"
                        />
                    </a-form-item>
                    <a-form-item label="仓库负责人" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
                        <a-select
                            v-decorator="['principalId',{rules: [{ required: true, message: '请选择仓库负责人'}]}]"
                            placeholder="请选择"
                        >
                            <a-select-option
                            :value="item.id"
                            v-for="(item, index) in principalOptions"
                            :key="index"
                            >{{item.principal}}</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-form>
            </a-modal>
        </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    export default {
        name: 'storageIndex',
        components: {},
        props: {},
        data() {
            const columns = [
                {
                    title: '仓库编号',
                    dataIndex: 'id',
                },
                {
                    title: '仓库名称',
                    dataIndex: 'name'
                },
                {
                    title: '仓库级别',
                    dataIndex: 'warehouseLevel',
                    scopedSlots: { customRender: 'warehouseLevel' }
                },
                {
                    title: '仓库类型',
                    dataIndex: 'warehouseType'
                },
                {
                    title: '仓库负责人',
                    dataIndex: 'principal'
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    scopedSlots: {
                        customRender: 'action'
                    }
                }
            ];
            return {
                columns,
                warehouse: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                newStorageVisible: false, //添加仓库
                filterForm: this.$form.createForm(this), //筛选表单
                formModelNewStorage: this.$form.createForm(this), //添加和编辑表单
                warehouseTypeOptions: [],
                principalOptions: [],
                storageTitle: '',
                id: '',
                flag: false // 仓库名称是否重复
            };
        },
        beforeCreate() {},
        watch: {},
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.warehouseList();
            },
            // 重置筛选
            handleReset() {
                this.filterForm.resetFields();
                this.warehouseList();
            },
            search() {
                this.pagination.current = 1;
                this.warehouseList();
            },
            //获取仓库信息列表
            warehouseList() {
                this.filterForm.validateFields((err, values) => {
                    values.shopId = this.shopId
                    if(!this.shopId) return
                    this.$api.storage.warehouseList({ body: {
                        ...values,
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize
                    } }).then(res => {
                        this.warehouse = res.data;
                        this.pagination.total = res.total;
                    });
                })
            },
            // 检查仓库名称是否存在 存在返回true 否false
            isWarehouseNameExist() {
                if(!this.shopId) return
                let values = {
                    id: this.id,
                    shopId: this.shopId,
                    warehouseName: this.formModelNewStorage.getFieldValue('name'),
                }
                this.$api.storage.isWarehouseNameExist({ body: values }).then(res => {
                    if(res) {
                        this.$message.error('仓库名称不能重复，请重新输入')
                    }
                    this.flag = res
                });
            },
            // 打开新增、编辑仓库弹窗
            openMondal(row = null) {
                this.newStorageVisible = true;
                this.storageTitle = row ? '编辑仓库' : '新增仓库'
                if(row) {
                    this.toEditerRow(row)
                    this.id = row.id
                }else {
                    this.id = undefined
                }
            },
            // 添加编辑仓库
            addWarehouse() {
                if(this.flag) {
                    this.$message.error('仓库名称不能重复，请重新输入')
                    return false
                }
                this.formModelNewStorage.validateFields((err, values) => {
                    if (!err) {
                        values.shopId = this.shopId
                        values.id = this.id
                        this.$api.storage[this.id ? 'updateStorage' : 'addStorage']({ body: values }).then(res => {
                            this.$message.success('操作成功')
                            this.warehouseList()
                            this.handleCancel()
                        });
                    }
                });
            },
            //编辑回填
            toEditerRow(row) {
                let value = {
                    name: row.name,
                    warehouseTypeId: row.warehouseTypeId,
                    principalId: row.principalId,
                }
                this.$nextTick(() => {
                    this.formModelNewStorage.setFieldsValue(value);
                });
            },
            // 取消添加仓库
            handleCancel() {
                this.newStorageVisible = false;
                this.formModelNewStorage.resetFields();
            },
            //跳转到仓库仓储
            toWareHouse(row) {
                this.$router.push({
                    name: 'storageSave',
                    query: { id: row.id, name: row.name, warehouseTypeId: row.warehouseTypeId, warehouseLevel:row.warehouseLevel }
                });
            },
            //删除仓库信息列表
            delectWarehouseList(id) {
                this.$api.storage
                    .delectStorage({ params: { id: id } })
                    .then(res => {
                        this.$message.success('操作成功')
                        this.warehouseList()
                    });
            },
            //仓库类型列表
            getTypeList(params) {
                this.$api.storage.getTypeList().then(res => {
                    this.warehouseTypeOptions = res;
                });
            },
            //仓库负责人列表
            getPrincipal(params) {
                if(!this.shopId) return
                this.$api.storage.getPrincipal({
                    params: {
                        shopId: this.shopId
                    }
                }).then(res => {
                    this.principalOptions = res;
                });
            }
        },
        created() {},
        mounted() {
            this.warehouseList();
            this.getTypeList();
            this.getPrincipal();
        },
        watch: {
            '$route'(val) {
                val.name == 'storageIndex' && this.warehouseList();
            },
            'shopId'() {
                this.warehouseList()
                this.getTypeList();
                this.getPrincipal();
            }
        }
    };
</script>
<style lang="scss">
  .wrap-container-in {
      background-color: #fff;
      padding: 24px 32px;
      border-radius: 2px;
  }
  .delectVisible {
      .delect_tips {
          text-align: center;
          height: 50px;
          font-weight: bold;
          font-size: 20px;
      }
      .delect_btn {
          display: flex;
          justify-content: space-around;
      }
  }
</style>
